export const types = {
  DATA_POINT_LIST: "[DataPoints] Data Point List",
  DATA_POINT_LIST_SUCCESS: "[DataPoints] Data Point List Success",
  DATA_POINT_LIST_FAILED: "[DataPoints] Data Point List Failed",
  CLEAR_DATA_POINT_LIST: "[DataPoints] Clear Data Point List",
  LOAD_MORE_DATAPOINT: "[DataPoints] Load More DataPoint",
  LOAD_MORE_DATAPOINT_SUCCESS: "[DataPoints] Load More DataPoint success",
  LOAD_MORE_DATAPOINT_FAILED: "[DataPoints] Load More DataPoint failed",
};

export const FetchDataPointList = (
  dataPointId,
  group,
  order,
  order_By,
  query,
  page,
  size,
  filters,
) => ({
  type: types.DATA_POINT_LIST,
  payload: {
    dataPointId,
    group,
    order,
    order_By,
    query,
    page,
    size,
    filters,
  },
});

export const FetchDataPointListSuccess = (list) => ({
  type: types.DATA_POINT_LIST_SUCCESS,
  payload: list,
});
export const FetchDataPointListFailed = (error) => ({
  type: types.DATA_POINT_LIST_FAILED,
  payload: error,
});

export const LoadMoreDataPoint = (
  dataPointId,
  group,
  order,
  order_By,
  query,
  page,
  size,
  filters,
) => ({
  type: types.LOAD_MORE_DATAPOINT,
  payload: {
    dataPointId,
    group,
    order,
    order_By,
    query,
    page,
    size,
    filters,
  },
});

export const LoadMoreDataPointSuccess = (list) => ({
  type: types.LOAD_MORE_DATAPOINT_SUCCESS,
  payload: list,
});
export const LoadMoreDataFailed = (error) => ({
  type: types.LOAD_MORE_DATAPOINT_FAILED,
  payload: error,
});
export const ClearDataPointList = () => ({
  type: types.CLEAR_DATA_POINT_LIST,
});
